var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTncIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.418,
    height: 21.996,
    viewBox: "0 0 18.418 21.996",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9231",
    d: "m2.272 22.4 13.868-.011a2.172 2.172 0 0 0 1.687-.686 2.668 2.668 0 0 0 .583-1.9V2.673a2.18 2.18 0 0 0-.607-1.6A2.49 2.49 0 0 0 16.1.4H2.272A2.274 2.274 0 0 0 0 2.673v17.452A2.275 2.275 0 0 0 2.272 22.4zM16.083 1.9a1.023 1.023 0 0 1 .666.228.693.693 0 0 1 .172.549v17.157a.77.77 0 0 0 0 .079 1.214 1.214 0 0 1-.208.793.693.693 0 0 1-.576.189l-13.869.011a.781.781 0 0 1-.78-.781V2.673a.781.781 0 0 1 .78-.78h13.815z",
    transform: "translate(0 -.402)",
    style: {
      fill: "#254089"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9232",
    d: "M3.359 6.336H13.6a.746.746 0 0 0 0-1.492H3.359a.746.746 0 0 0 0 1.492z",
    transform: "translate(.73 .837)",
    style: {
      fill: "#254089"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9233",
    d: "M3.359 10.3H13.6a.746.746 0 0 0 0-1.492H3.359a.746.746 0 0 0 0 1.492z",
    transform: "translate(.73 1.943)",
    style: {
      fill: "#254089"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9234",
    d: "M3.359 14.26H13.6a.746.746 0 0 0 0-1.492H3.359a.746.746 0 0 0 0 1.492z",
    transform: "translate(.73 3.049)",
    style: {
      fill: "#254089"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTncIcon);
export default __webpack_public_path__ + "static/media/tnc-icon.5577c0de01483906d8c7ccac2ed6cd64.svg";
export { ForwardRef as ReactComponent };